// extracted by mini-css-extract-plugin
export default {"container":"landingPage_container__ptTK1","image":"landingPage_image__X09D9","start":"landingPage_start__9ctCf","shake3856":"landingPage_shake3856__FPlsu"};